module.exports = __webpack_public_path__ + "img/merhavia.bd89a19a.png";